import { all, put, take, race, select, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { getToken, getLocale } from '@global/selectors'

import { blockSaveCustomData } from '../../../../../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../../../../../config'

import {
    LIENS_DEBTOR_TABLE_CHANGE,
    LIENS_DEBTOR_TABLE_LOADING_TRUE,
    LIENS_DEBTOR_TABLE_LOADING_FALSE,
    LIENS_DEBTOR_TABLE_CHANGE_REQUEST,
    LIENS_DEBTOR_TABLE_DATA_RECEIVED,
} from './constants'

import {
    debtorsTableLoadingTrue,
    debtorTableChangeRequest,
    debtorsTableDataReceived,
    debtorsTableLoadingFalse,
} from './actions'

const LIENS_DEBTOR_TABLE_CHANGE_REQUEST_SUCCESS = (id) => `${LIENS_DEBTOR_TABLE_CHANGE_REQUEST(id)}_${SUCCESS}`
const LIENS_DEBTOR_TABLE_CHANGE_REQUEST_FAILED = (id) => `${LIENS_DEBTOR_TABLE_CHANGE_REQUEST(id)}_${FAILED}`

function* liensDebtorTableCallSaga(action) {
    const block = _.get(action, 'data.block', null)
    if (block !== config.modules.report.blocks.liens.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !block || !id) return null

    const level = _.get(action, 'data.level', null)
    const customData = _.get(action, 'data.customData', null)
    const qs = _.get(action, 'data.qs', null)
    const locale = yield select(getLocale)
    const token = yield select(getToken, id, module)
    const lang = config.languages[locale].requestKey

    yield put(
        debtorsTableLoadingTrue(module, block, id, {
            ...customData,
            debtor: {
                ...customData.debtor,
                table: {
                    ...customData.debtor.table,
                    isLoading: true,
                },
            },
        })
    )

    const filters = _.reduce(
        _.get(qs, 'filtered'),
        (acc, filter) => ({
            ...acc,
            [`${filter.id}[]`]: filter.value,
        }),
        {}
    )

    const qp = {
        'sort[]': _.map(_.get(qs, 'sorted', []), (val) => `${_.get(val, 'id')}${val.desc ? ':desc' : ':asc'}`),
        page: _.get(qs, 'pagination.page'),
        rows: _.get(qs, 'pagination.rowsPerPage'),
        ...filters,
    }

    yield put(debtorTableChangeRequest(module, block, id, level, lang, token, qp))

    const response = yield race({
        success: take(LIENS_DEBTOR_TABLE_CHANGE_REQUEST_SUCCESS(id)),
        failed: take(LIENS_DEBTOR_TABLE_CHANGE_REQUEST_FAILED(id)),
    })

    if (!response.failed) {
        const data = _.map(_.get(response, 'success.payload.response.body.data'), (row) => ({ ...row }))
        const query = _.get(response, 'success.payload.response.body.query', [])
        const pagination = _.get(query, 'pagination', null)
        const sorted = _.reduce(
            _.get(query, 'sort.sortedColumns'),
            (acc, val) => [
                ...acc,
                {
                    id: _.get(val, 'columm'), // TYPO FROM BACKEND
                    desc: _.get(val, 'direction') === 'desc',
                },
            ],
            []
        )
        const filter = _.get(query, 'filter', null)

        const newCustomData = {
            ...customData,
            debtor: {
                ...customData.debtor,
                table: {
                    data,
                    pagination,
                    sorted,
                    isLoading: false,
                    filter,
                },
            },
        }

        yield put(debtorsTableDataReceived(module, block, id, newCustomData))
    } else {
        yield put(
            debtorsTableLoadingFalse(module, block, id, {
                ...customData,
                debtor: {
                    ...customData.debtor,
                    table: {
                        ...customData.debtor.table,
                        isLoading: false,
                    },
                },
            })
        )
    }

    return null
}

function* liensChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.liens.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* liensDebtorTableSaga() {
    yield all([
        takeEvery(LIENS_DEBTOR_TABLE_CHANGE, liensDebtorTableCallSaga),
        takeEvery(LIENS_DEBTOR_TABLE_LOADING_TRUE, liensChangeCustomData),
        takeEvery(LIENS_DEBTOR_TABLE_LOADING_FALSE, liensChangeCustomData),
        takeEvery(LIENS_DEBTOR_TABLE_DATA_RECEIVED, liensChangeCustomData),
    ])
}
